function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPc03 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.02522,62.54826c8.0525,7.65647,20.39393,4.31795,20.39393,4.31795s2.17448-2.68612.63955-5.24433S76.163,58.04038,76.163,58.04038C77.82585,55.35426,77.59322,46.404,77.59322,46.404",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.62329,38.92859,42.0945,33.97788a8.44935,8.44935,0,0,0-10.60907-5.32362l-7.8992,2.56255a8.44787,8.44787,0,0,1-10.0825-4.09845",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6006,59.29284A3.43625,3.43625,0,0,0,21.41074,56.851c-1.24772-1.1826-3.15843.86757-3.15843.86757S9.92684,65.27433,11.98022,68.273c1.97514,2.88439,3.68143,3.13314,5.16826,1.91966a4.79236,4.79236,0,0,0,1.65577-5.24711",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.10542,81.76761A4.79235,4.79235,0,0,1,31.74,86.598c-.15585,1.91283-1.51782,2.97035-4.966,2.39486-3.5847-.59828-3.26053-11.8365-3.26053-11.8365s-.15347-2.7983,1.5638-2.878a3.43624,3.43624,0,0,1,2.58484.8348",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.51685,52.69845l-2.08788.60027-2.21838-7.77085a4.10189,4.10189,0,0,1,1.44847-4.39761c3.94088-3.01438,12.27285-9.16712,17.77965-11.64648a5.346,5.346,0,0,1,5.25886.48935l5.51333,3.843.92649.8221",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.395,66.88279l-1.48317,1.249A3.20831,3.20831,0,0,1,53.803,68.71c-7.42779-2.55915-9.79846-9.48854-10.55287-13.43919a4.483,4.483,0,0,1,1.67523-4.4087l.4596-.35146",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.46733,46.96982l-.08482.06525-2.30973,1.853a3.79011,3.79011,0,0,0-1.42237,2.95567c0,.09787.00653.19574.013.29361a16.95223,16.95223,0,0,0,9.59775,13.96925l.91345.43716a3.76534,3.76534,0,0,0,3.98656-.45673l5.89827-4.5803a44.55912,44.55912,0,0,0,5.696-5.285l.39147-.43715a2.80387,2.80387,0,0,0-.32623-4.0779L67.48839,48.2356a2.8182,2.8182,0,0,0-3.69295.15659l-5.27191,5.0044",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.06468,
    y1: 63.60113,
    x2: 58.6475,
    y2: 59.56238,
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.778,53.45075s-1.473,2.35676-.73649,4.27164a2.32594,2.32594,0,0,1-.01637,1.72938,1.80305,1.80305,0,0,0,1.398,2.4879A3.51239,3.51239,0,0,0,58.19692,60.521c1.76758-2.94595.2946-7.21759.2946-7.21759",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.34962,
    y1: 35.4452,
    x2: 60.83851,
    y2: 29.68485,
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.06587,36.9534s-10.16354-4.86083-14.43518,1.03108-6.4811,7.80678-1.62028,13.4041a11.48078,11.48078,0,0,0,3.12194,2.70251A2.1049,2.1049,0,0,0,58.08,51.588l-1.20874-4.02913s4.86083-2.79866,4.41894-6.33381",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.322,44.60842l-.00713.00712A8.50716,8.50716,0,0,1,77.59322,46.404a3.90162,3.90162,0,0,1-1.42508-.30639c-1.53195-.66978-5.27989-2.65064-6.54108-6.41995a6.09914,6.09914,0,0,1,.513-4.52461",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8331,66.46658s2.65922,1.737,5.03426-.11551a3.69218,3.69218,0,0,1,2.36345-.19562,1.80305,1.80305,0,0,0,2.19769-1.82051,3.5124,3.5124,0,0,0-2.07083-3.45914c-3.21463-1.21207-7.15387,1.00129-7.15387,1.00129h0a5.834,5.834,0,0,1-.12169,3.961Z",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0271,69.14727,44.29373,80.7205A4.75953,4.75953,0,0,1,40.59588,82.239l-10.76174-.4711a2.80071,2.80071,0,0,1-2.57088-2.04838,4.8784,4.8784,0,0,1-.04285-2.73069,2.72831,2.72831,0,0,1,2.34437-1.86917l6.67949-.71481a2.99968,2.99968,0,0,0,1.83218-.89227l5.36817-5.52476",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.47735,67.28441,31.57879,71.49376a4.37884,4.37884,0,0,1-3.64215-.5107l-8.38727-5.40795a2.44926,2.44926,0,0,1-1.08146-2.58368,4.56593,4.56593,0,0,1,1.32638-2.4287,2.44524,2.44524,0,0,1,2.63072-.38064l5.69234,2.558a2.75977,2.75977,0,0,0,1.86955.14191l6.18876-3.60061s3.80068-5.8472,6.87046-5.8472",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.46337,23.86435A8.44064,8.44064,0,0,0,3.06042,23.146l-.63033.2365",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.39835,52.87134c-1.44728,2.25041-2.98727,1.57183-4.87855,1.09425",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.14819,44.93237a4.62214,4.62214,0,0,1-1.73652-.37679c-1.874-.81769-6.45131-3.23264-7.99287-7.84052-1.957-5.84973,6.36723-15.81565,15.5339-8.89646C93.798,33.74042,90.55342,45.187,80.14819,44.93237Z",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.47205,33.81326a12.7126,12.7126,0,0,0-8.79092-3.49312,3.94738,3.94738,0,0,0-3.3017,1.66228l-1.54365,3.01023a3.63152,3.63152,0,0,0,.39662,3.96919c1.93607,2.33925,5.63732,4.25453,7.68681,5.19431,0,0,2.86857.06748,5.27865-3.71978A5.994,5.994,0,0,0,89.47205,33.81326Z",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3049284050599155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.79966,43.13427a5.80457,5.80457,0,0,0,4.91341-4.91364h.11746a5.80457,5.80457,0,0,0,4.91341,4.91364v.11742a5.80456,5.80456,0,0,0-4.91337,4.91322H15.713a5.80454,5.80454,0,0,0-4.91337-4.91322Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.403,15.54424a3.37332,3.37332,0,0,0,2.85541-2.85555h.06826a3.37332,3.37332,0,0,0,2.85541,2.85555v.06824a3.37329,3.37329,0,0,0-2.85538,2.85529h-.06831A3.37329,3.37329,0,0,0,52.403,15.61248Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.95014,77.70277a2.09526,2.09526,0,0,0,1.77358-1.77366h.0424a2.09526,2.09526,0,0,0,1.77358,1.77366v.04239a2.09526,2.09526,0,0,0-1.77356,1.77351h-.04243a2.09527,2.09527,0,0,0-1.77357-1.77351Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPc03);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PC03.2beb251c925286b685185d3118c0f8db.svg";